import React, { useState, useEffect } from 'react';
import Navbar from '../Shared/Navbar';
import api from '../../config/api';
import './PortfolioManager.css';

function PortfolioManager({ user, onLogout }) {
  const [projects, setProjects] = useState([]);
  const [showNewProject, setShowNewProject] = useState(false);
  const [newProject, setNewProject] = useState({
    name: '',
    description: '',
    collection: '',
    season: '',
    visibility: 'private'
  });

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await api.get('/api/portfolio');
      setProjects(response.data.projects);
    } catch (error) {
      console.error('Failed to fetch projects:', error);
    }
  };

  const handleCreateProject = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/portfolio/projects', newProject);
      
      setShowNewProject(false);
      setNewProject({ name: '', description: '', collection: '', season: '', visibility: 'private' });
      fetchProjects();
    } catch (error) {
      alert('Failed to create project: ' + (error.response?.data?.error || error.message));
    }
  };

  return (
    <div>
      <Navbar user={user} onLogout={onLogout} userType="creator" />
      
      <div className="portfolio-container">
        <div className="portfolio-header">
          <div>
            <h1>Portfolio Manager</h1>
            <p className="text-gray-600">Organize and manage your fashion projects</p>
          </div>
          <button
            className="btn btn-primary"
            onClick={() => setShowNewProject(true)}
          >
            + New Project
          </button>
        </div>

        {/* New Project Modal */}
        {showNewProject && (
          <div className="modal-overlay" onClick={() => setShowNewProject(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h2>Create New Project</h2>
              <form onSubmit={handleCreateProject}>
                <div className="form-group">
                  <label>Project Name *</label>
                  <input
                    type="text"
                    className="input"
                    value={newProject.name}
                    onChange={(e) => setNewProject({...newProject, name: e.target.value})}
                    required
                    placeholder="e.g., FW24 Outerwear Collection"
                  />
                </div>

                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    className="input"
                    rows="3"
                    value={newProject.description}
                    onChange={(e) => setNewProject({...newProject, description: e.target.value})}
                    placeholder="Describe your project..."
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Collection</label>
                    <input
                      type="text"
                      className="input"
                      value={newProject.collection}
                      onChange={(e) => setNewProject({...newProject, collection: e.target.value})}
                      placeholder="e.g., Fall/Winter 2024"
                    />
                  </div>

                  <div className="form-group">
                    <label>Season</label>
                    <select
                      className="input"
                      value={newProject.season}
                      onChange={(e) => setNewProject({...newProject, season: e.target.value})}
                    >
                      <option value="">Select...</option>
                      <option value="SS24">SS24</option>
                      <option value="FW24">FW24</option>
                      <option value="SS25">SS25</option>
                      <option value="FW25">FW25</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Visibility</label>
                  <select
                    className="input"
                    value={newProject.visibility}
                    onChange={(e) => setNewProject({...newProject, visibility: e.target.value})}
                  >
                    <option value="private">Private</option>
                    <option value="connections">Connections Only</option>
                    <option value="members">Platform Members</option>
                    <option value="public">Public</option>
                  </select>
                </div>

                <div className="modal-actions">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowNewProject(false)}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Create Project
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Projects Grid */}
        {projects.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📁</div>
            <h3>No projects yet</h3>
            <p>Create your first project to start building your portfolio</p>
            <button className="btn btn-primary" onClick={() => setShowNewProject(true)}>
              Create Project
            </button>
          </div>
        ) : (
          <div className="projects-grid">
            {projects.map(project => (
              <div key={project.id} className="project-card card">
                <div className="project-header">
                  <h3>{project.name}</h3>
                  <span className="visibility-badge badge badge-info">
                    {project.visibility}
                  </span>
                </div>
                {project.description && (
                  <p className="project-description">{project.description}</p>
                )}
                <div className="project-meta">
                  {project.collection && (
                    <span className="meta-item">📚 {project.collection}</span>
                  )}
                  {project.season && (
                    <span className="meta-item">🗓️ {project.season}</span>
                  )}
                </div>
                <div className="project-stats">
                  <span>{project.assets?.length || 0} assets</span>
                  <span>{new Date(project.createdAt).toLocaleDateString()}</span>
                </div>
                <div className="project-actions">
                  <button className="btn btn-secondary btn-sm">Edit</button>
                  <button className="btn btn-primary btn-sm">View</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PortfolioManager;
